import { ContextAction } from '../types';
import type { RouterAction, RouterState } from './types';
import { DASHBOARD_URL } from '$constants/common';

export const routeinitial = { routePathName: DASHBOARD_URL.home };

export const routeReducer = (
  state: RouterState,
  action: RouterAction
): RouterState => {
  switch (action.type) {
    case ContextAction.setRoute:
      return { ...state, routePathName: action.payload.routePathName };
    default:
      return state;
  }
};
